module.exports = __webpack_public_path__ + "static/media/icon-organic.79b7f481.svg";